module.exports = __webpack_public_path__ + "static/media/04_quote_mobile.82713102.jpg";